import { render, staticRenderFns } from "./KoioteValueLabelWriteOne.vue?vue&type=template&id=69a36412&lang=es&"
import script from "./KoioteValueLabelWriteOne.vue?vue&type=script&lang=js&"
export * from "./KoioteValueLabelWriteOne.vue?vue&type=script&lang=js&"
import style0 from "./KoioteValueLabelWriteOne.vue?vue&type=style&index=0&id=69a36412&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports